import jw_red from "./jw_red.png";
import jw_black from "./jw_black.png";
import jw_double_black from "./jw_double_black.png";
import jw_gold from "./jw_gold.png";
import jw_green from "./jw_green.png";
import jw_platinum from "./jw_18.png"; // Check if this is the correct image

export default {
    jw_red,
    jw_black,
    jw_double_black,
    jw_gold,
    jw_green,
    jw_platinum
};



// WEBPACK FOOTER //
// ./src/imgs/bottles/balloons/index.js